"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileType = void 0;
var FileType;
(function (FileType) {
    FileType[FileType["UNKNOWN"] = 0] = "UNKNOWN";
    FileType[FileType["DELIVERY_RECEIPT"] = 1] = "DELIVERY_RECEIPT";
    FileType[FileType["SIGNATURE"] = 2] = "SIGNATURE";
    FileType[FileType["CARRIER_DOCUMENT"] = 3] = "CARRIER_DOCUMENT";
    FileType[FileType["CLAIM_DOCUMENT"] = 4] = "CLAIM_DOCUMENT";
    FileType[FileType["DOCUMENTS_ZIP"] = 5] = "DOCUMENTS_ZIP";
    FileType[FileType["PROOF_OF_DELIVERY"] = 6] = "PROOF_OF_DELIVERY";
    FileType[FileType["BILL_OF_LADING"] = 7] = "BILL_OF_LADING";
    FileType[FileType["SHIPMENT_NOTE_DOCUMENT"] = 8] = "SHIPMENT_NOTE_DOCUMENT";
    FileType[FileType["SHIPMENT_DOCUMENT"] = 9] = "SHIPMENT_DOCUMENT";
    FileType[FileType["ORGANIZATION_DOCUMENT"] = 10] = "ORGANIZATION_DOCUMENT";
    FileType[FileType["ONBOARDING_DOCUMENT"] = 11] = "ONBOARDING_DOCUMENT";
    FileType[FileType["SHIPMENT_ISSUE_PHOTO"] = 12] = "SHIPMENT_ISSUE_PHOTO";
    FileType[FileType["ACCOUNTING_DOCUMENT"] = 13] = "ACCOUNTING_DOCUMENT";
    FileType[FileType["CARRIER_EARNINGS"] = 14] = "CARRIER_EARNINGS";
    FileType[FileType["GEO_DATA"] = 15] = "GEO_DATA";
    FileType[FileType["FREIGHT_PHOTO"] = 16] = "FREIGHT_PHOTO";
    FileType[FileType["SCHEDULE_STOP_WAIT_PERIOD_PHOTO"] = 17] = "SCHEDULE_STOP_WAIT_PERIOD_PHOTO";
    FileType[FileType["SHIPMENT_UNASSIGNMENT_PHOTO"] = 18] = "SHIPMENT_UNASSIGNMENT_PHOTO";
    FileType[FileType["CARRIER_SHIPMENT_ADJUSTMENT_PHOTO"] = 19] = "CARRIER_SHIPMENT_ADJUSTMENT_PHOTO";
    FileType[FileType["REDELIVERY_LOCATION_PHOTO"] = 20] = "REDELIVERY_LOCATION_PHOTO";
    FileType[FileType["DELIVERY_ATTEMPT_LOCATION_PHOTO"] = 21] = "DELIVERY_ATTEMPT_LOCATION_PHOTO";
})(FileType || (exports.FileType = FileType = {}));
//# sourceMappingURL=FileType.js.map